import { createSlice } from '@reduxjs/toolkit';
import { AlertMessagesStateType } from 'src/types/alertMessages';
import translate from '@translate';

const initialState: AlertMessagesStateType = {
    index: 0,
    messages: [],
    abbleMessages: false
};

const alertMessagesSlice = createSlice({
    name: 'alertMessages',
    initialState,
    reducers: {
        addMessage: (state, action) => {
            state.index = state.index + 1;
            state.messages = [
                ...state.messages,
                {
                    id: state.index,
                    type: action.payload.type,
                    title: action.payload.title,
                    text: action.payload.text
                }
            ];
        },
        removeMessage: (state, action) => {
            state.messages = state.messages.filter((message) => message.id !== action.payload);
        },
        disabbleMessages: (state) => {
            state.abbleMessages = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(
                (action) => ['login/loginFetchSuccess', 'user/getUserFetchSuccess'].includes(action.type),
                (state, action) => {
                    state.abbleMessages = true;
                }
            )
            .addMatcher(
                (action) => ['login/logoutFetch'].includes(action.type),
                (state, action) => {
                    state.abbleMessages = false;
                }
            )
            .addMatcher(
                (action) => action.payload?.messageSuccess,
                (state, action) => {
                    state.index = state.index + 1;
                    const getMessageText = (text: string): string => {
                        const ignoredMessages = ['REQUIRED_EXPEDITION_DATE_RECALCULATED', 'OK'];
                        return ignoredMessages.includes(text) ? '' : text;
                    };
                    const messages = [
                        ...state.messages,
                        {
                            id: state.index,
                            type: 'success',
                            title: action.payload.messageSuccess.title,
                            text: getMessageText(action.payload.messageSuccess.text)
                        }
                    ];
                    if (action.payload.messageSuccess.text === 'REQUIRED_EXPEDITION_DATE_RECALCULATED') {
                        state.index = state.index + 1;
                        messages.push({
                            id: state.index,
                            type: 'success',
                            title: translate('orders.message.requiredExpeditionDateRecalculated'),
                            text: ''
                        });
                    }
                    // @ts-ignore
                    state.messages = messages;
                }
            )
            .addMatcher(
                (action) => action.payload?.error,
                (state, action) => {
                    if (state.abbleMessages && !action.payload?.noMessage) {
                        const customErrors = ['PRODUCT_SET_CONTAINS_PRODUCTS', 'PRODUCT_SET_USED_IN_ORDERS'];
                        const errorCode = action.payload.error?.response?.data?.errorCode;
                        const errorData = action.payload.error?.response?.data?.errorData;
                        let errorTitle = action.payload.error?.response?.data?.error || action.payload.message;
                        let errorMessage =
                            action.payload.error?.response?.data?.message ||
                            (action.payload.error && action.payload.error.message) ||
                            '';

                        if (typeof errorTitle !== 'string') {
                            errorTitle = errorMessage;
                            errorMessage = '';
                        }
                        if (errorCode && customErrors.includes(errorCode)) {
                            errorMessage = translate(`apiErrors.${errorCode}`, errorData);
                        }
                        if (errorTitle === errorMessage) {
                            errorTitle = translate('apiErrors.serverErrorTitle');
                        }
                        state.index = state.index + 1;
                        state.messages = [
                            ...state.messages,
                            {
                                id: state.index,
                                type: 'error',
                                title: customErrors.includes(errorCode) ? translate('apiErrors.serverErrorTitle') : errorTitle,
                                text: errorMessage
                            }
                        ];
                    }
                    // state.messages = [
                    //     ...state.messages,
                    //     {
                    //         id: state.index,
                    //         type: 'error',
                    //         title: action.payload.message,
                    //         text: (action.payload.error && action.payload.error.message) || '',
                    //     },
                    // ];
                }
            )
            .addMatcher(
                (action) => action.error?.response,
                (state, action) => {
                    if (state.abbleMessages) {
                        let errorTitle = action.error.response.data?.error;
                        let errorMessage = action.error.response.data?.message;
                        if (typeof errorTitle !== 'string') {
                            errorTitle = errorMessage;
                            errorMessage = '';
                        }
                        state.index = state.index + 1;
                        state.messages = [
                            ...state.messages,
                            {
                                id: state.index,
                                type: 'error',
                                title: errorTitle,
                                text: errorMessage
                            }
                        ];
                    }
                }
            );
    }
});

export const { addMessage, removeMessage, disabbleMessages } = alertMessagesSlice.actions;

export default alertMessagesSlice.reducer;
